/**
 * BrandHeader — matches the branding on www.targetfunder.com exactly.
 * Used on onboarding, welcome, stripe-connected, setup-guide, and admin magic-link pages.
 *
 * Design source of truth: the marketing hero wordmark.
 *   - font-heading (Barlow Condensed), font-black, uppercase, tracking-tighter
 *   - logo height 56px (matches marketing mobile), with TARGET navy / FUNDER red / .com 30% navy
 */
export default function BrandHeader() {
  return (
    <header className="bg-white border-b border-[#1D3557]/5 px-6 py-4">
      <div className="max-w-6xl mx-auto flex items-center gap-3">
        <img
          src="https://www.targetfunder.com/tf_logo.png"
          alt="TargetFunder"
          className="object-contain w-auto"
          style={{ height: '56px' }}
        />
        <h1 className="font-heading font-black text-3xl sm:text-4xl uppercase tracking-tighter leading-[0.9] text-[#1D3557] m-0">
          target<span className="text-[#E63946]">funder</span>
          <span className="text-[#1D3557]/30 hidden sm:inline">.com</span>
        </h1>
      </div>
    </header>
  );
}
